export enum LegalPaths {
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  PRIVACY_POLICY = 'privacy-policy',
  AML_POLICY = 'aml-policy',
}
